<script setup lang="ts">
import { ref } from "vue";
import { XMarkIcon } from '@heroicons/vue/20/solid';
import { TrashIcon } from "@heroicons/vue/24/solid";

const emits = defineEmits(['close']);
</script>
<template>
  <!--
    Make sure you add some bottom padding to pages that include a sticky banner like this to prevent
    your content from being obscured when the user scrolls to the bottom of the page.
  -->
  <div
    class="sticky bottom-0 z-50 pointer-events-none sm:flex sm:justify-center sm:px-6 sm:pb-5 lg:px-8"
  >
    <div class="pointer-events-auto shadow-xl flex items-center border-2 border-red-600 justify-between gap-x-6 bg-red-900 px-6 py-2.5 sm:rounded-xl sm:py-3 sm:pl-4 sm:pr-3.5">
      <p class="text-sm leading-6 text-white">
        <span class="inline-flex items-center">
          <!-- <strong class="font-semibold">Délai expiré</strong> -->
          <TrashIcon class="w-5 h-5" />
          <svg viewBox="0 0 2 2" class="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
            <circle cx="1" cy="1" r="1" />
          </svg>
          <span>Ce dossier a été clôturé</span>
          <!-- &nbsp;<span aria-hidden="true">&rarr;</span> -->
        </span>
      </p>
      <button @click="emits('close')" type="button" class="-m-1.5 flex-none p-1.5">
        <span class="sr-only">Fermer</span>
        <XMarkIcon class="w-5 h-5 text-white" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>
